import React, { Component } from 'react'
import * as actions from "../actions";
import * as utils from "../../utils";
import * as common_utils from "../../../common/utils";
import { likePost, unlikePost } from "../../posts/actions";

import DownloadFile from "../../posts/components/download-file";
import EditTagsLink from "../../posts/components/edit-tags-link";
import FeedPostHead from "../../posts/components/feed-post-head";
import LikesCount from "../../posts/components/likes-count";
import LikePost from "../../posts/components/like-post";

function SlideshowDetails(props) {
  const post = props.post;
  if (!post) {
    return null;
  }
  const { likes, liked, liked_by, replies, creator } = post;
  const replyCount = replies.total_count || 0;
  const truncateCommentAt = utils.isMobile() ? 75 : 0;
  return (
    <div className="slideshow-details" id="title-wrap">
      <div className="title">
        <FeedPostHead
          post={post}
          truncateCommentAt={truncateCommentAt}
          showMenu={utils.canEditEventItem(creator.id)}
        />
      </div>
      <DesktopPostActions post={post} />
      <MobileSocialStats
        likes={likes}
        liked={liked}
        likedBy={liked_by}
        replyCount={replyCount}
      />
      <MobilePostActions post={post} />
    </div>
  );
}

function DesktopPostActions(props) {
  const { id, likes, liked, liked_by, content, tags, creator } = props.post;
  return (
    <div className="post-actions">
      { likes > 0 &&
        <LikesCount liked={liked} likes={likes} likedBy={liked_by} />
      }
      { utils.canComment() &&
        <LikePost postId={id} likes={likes} liked={liked} />
      }
      <DownloadFile fileId={content.photo_id} fileType="image">
        Download
      </DownloadFile>
      { utils.canEditEventItem(creator.id) &&
        <EditTagsLink tags={tags} postId={id} showIcon={true} />
      }
    </div>
  )
}

const MobileSocialStats = React.createClass({
  render() {
    return (
      <ul className="social-stats">
        <li className="comments" onClick={this.handleCommentClick}>
          {common_utils.pluralize("comment", this.props.replyCount)}
        </li>
        { this.props.likes > 0 &&
          <li className="likes">
            <LikesCount likes={this.props.likes} liked={this.props.liked} likedBy={this.props.likedBy} />
          </li>
        }
      </ul>
    );
  },
  handleCommentClick(e) {
    actions.toggleSlideshowComments();
  }
});

const MobilePostActions = React.createClass({
  render() {
    const { id, likes, liked, content, creator, tags } = this.props.post;
    const likeClass = `button-like ${ liked ? 'liked' : '' }`;
    return (
      <div className="mobile-post-actions">
        <DownloadFile fileId={content.photo_id} fileType="image" />
        { utils.canEditEventItem(creator.id) &&
          <EditTagsLink tags={tags} postId={id} showIcon={true} hideText={true} />
        }
        <a href="#"
          className="button-comment"
          onClick={this.onCommentButtonClick}
        >
          <i className="icon-comment"></i>
        </a>
        { utils.canComment() &&
          <a href="#"
            className={likeClass}
            onClick={this.onLikeButtonClick}
          >
            <i className="icon-heart"></i>
          </a>
        }
      </div>
    );
  },
  onCommentButtonClick(e) {
    e.preventDefault();
    actions.toggleSlideshowComments();
  },
  onLikeButtonClick(e) {
    const { id, liked } = this.props.post;
    e.preventDefault();
    if (liked) {
      unlikePost(id);
    } else {
      likePost(id);
    }
  }
});

export default SlideshowDetails;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/slideshow/components/slideshow-details.es6